import { motion } from "framer-motion";
import { PhoneOff, Video } from "lucide-react";

interface CallingScreenProps {
  contactName: string;
  isVideo: boolean;
  onHangUp: () => void;
}

const CallingScreen = ({ contactName, isVideo, onHangUp }: CallingScreenProps) => {
  return (
    <motion.div
      initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
      className="fixed inset-0 z-[60] bg-background flex flex-col items-center justify-center gap-8"
    >
      <div className="w-28 h-28 rounded-full bg-sovereign-gold/20 border-2 border-sovereign-gold/40 flex items-center justify-center">
        <span className="text-4xl font-bold text-sovereign-gold">
          {contactName.slice(0, 2).toUpperCase()}
        </span>
      </div>

      <div className="text-center space-y-2">
        <p className="text-xl font-bold text-foreground">{contactName}</p>
        <p className="text-sm text-muted-foreground font-mono animate-pulse">
          {isVideo ? "Video Calling…" : "Voice Calling…"}
        </p>
      </div>

      <div className="flex items-center gap-3">
        {isVideo && (
          <div className="w-10 h-10 rounded-full bg-secondary border border-border flex items-center justify-center">
            <Video className="w-4 h-4 text-ai-cyan" />
          </div>
        )}
        <button
          onClick={onHangUp}
          className="w-16 h-16 rounded-full bg-destructive text-destructive-foreground flex items-center justify-center shadow-lg hover:bg-destructive/80 transition-colors"
        >
          <PhoneOff className="w-6 h-6" />
        </button>
      </div>
    </motion.div>
  );
};

export default CallingScreen;
